<template>
  <div class="cover-photo">
    <figure v-if="imageUrl">
      <img :src="imageUrl" :alt="imageAlt">
      <figcaption class="h9 nimbus-sans" v-html="text"></figcaption>
    </figure>
  </div>
</template>

<script>
export default {
  name: 'CoverPhoto',
  props: ['imageUrl', 'imageAlt', 'text'],
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../style/variables';
.cover-photo{
  position: relative;
  margin:$gutter $gutter $collection-blockMargin-ns;
  figure img{
    width:100%;
  }
  @include on_mobile() {
    margin:$collectionMobile-blockMargin-ns 0;
    figcaption{
      position: static;
      padding:0 $gutter;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Collection__Story__CoverPhoto.vue?7c44ef7a